module.exports = __webpack_public_path__ + "img/emoji_05.7f5a6780.png";